import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const Cab = ({ cab }: SpecProps<"cab">) => {
  const { i18n } = useLingui();

  if (!cab) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.cab",
    message: "Cab",
    comment: "Label for cab",
  });

  return <FieldValuePair field={field} value={cab} />;
};
